function isPageType(pageTypes) {
  const pageType = window.dataLayer?.[0]?.shoptet?.pageType;
  return pageTypes.includes(pageType);
}
const language = dataLayer[0].shoptet.language;

// ! Homepage
function handleHomepage() {
  const carouselElement = document.querySelector(".carousel");
  const carousel =
    document.querySelector(".homepage-box.before-carousel") ||
    carouselElement?.closest(".content-wrapper");

  const elements = [
    document.querySelector("[class*='custom-footer__banner']:has(#smlxl)"), // interierBanner
    document.querySelector(
      "[class*='custom-footer__banner']:has(#spravne-reseni)"
    ), // spravneReseniBanner
    document.querySelector(
      "[class*='custom-footer__banner']:has(.kolekce-navigation)"
    ), // kolekceBanner
    document.querySelector(".homepage-box.welcome-wrapper"), // welcome
  ];

  if (carousel) {
    elements.forEach((el) => {
      if (el) carousel.after(el);
    });
  }

  if (window.innerWidth < 768) {
    const buttons = [
      {
        selector: "#classix .controls-row.container .btn.btn-secondary",
        oldText: "Přehled všech produktů Raxi Classix",
        newText: "Přehled produktů Raxi Classix",
      },
      {
        selector: "#array .btn.btn-secondary",
        oldText: "Přehled všech produktů Raxi Array",
        newText: "Přehled produktů Raxi Array",
      },
    ];

    buttons.forEach(({ selector, oldText, newText }) => {
      const btn = document.querySelector(selector);
      if (btn && btn.textContent.includes(oldText)) {
        btn.textContent = newText;
      }
    });
  }
}
function handleFooter() {
  const footerBottom = document.querySelector(".footer-bottom");
  const footerGlobal = document.querySelector("#footer");

  if (footerBottom && footerGlobal) {
    addBackToTop(footerGlobal);
    wrapFooterBottom(footerBottom, footerGlobal);
    updateSignature(footerBottom);
  }

  updateFooterLinks();
  handleFooterHeaders();
}

// Create "Zpět nahoru" button
function addBackToTop(footerGlobal) {
  if (!document.querySelector(".back-to-top")) {
    const link = document.createElement("a");
    link.className = "back-to-top btn btn-primary";
    link.href = "#";
    link.setAttribute("aria-label", "Zpět nahoru");
    link.textContent = "Nahoru";
    footerGlobal.appendChild(link);
  }
}

// Wrapper for footer bottom
function wrapFooterBottom(footerBottom, footerGlobal) {
  const wrapper = document.createElement("div");
  wrapper.className = "footer-bottom-wrapper";
  wrapper.appendChild(footerBottom);
  footerGlobal.parentElement.insertBefore(
    wrapper,
    footerGlobal.nextElementSibling
  );
}

// Update signature in footer bottom
function updateSignature(footerBottom) {
  const signature = footerBottom.querySelector("#signature");
  if (!signature) return;

  signature.style.setProperty("display", "flex", "important");
  signature.innerHTML = `
    Vytvořila 
    <a href="https://www.mirandamedia.cz" class="title" target="_blank">
      MirandaMedia Group s.r.o. 
      <img src="/user/documents/upload/miranda/miranda-logo.svg" width="17" height="17" alt="MirandaMedia Group s.r.o." class="vam" loading="lazy" fetchpriority="low">
    </a>
    <div>na platformě 
      <a href="https://www.shoptetpremium.cz/?utm_source=footer&amp;utm_medium=link&amp;utm_campaign=create_by_shoptet" class="image" target="_blank">
        <img src="/user/documents/upload/miranda/shoptet-logo.svg" width="17" height="17" alt="Shoptet Premium" class="vam" loading="lazy" fetchpriority="low">
      </a>
    </div>
  `;

  // Původní kód pro platební metody - zachováno jako komentář:
  // const platebniMetodyEl = document.createElement("img");
  // platebniMetodyEl.src =
  //   "/user/documents/upload/miranda/payment-footer.svg";
  // platebniMetodyEl.alt = "Platební metody";
  // signature.parentElement.insertBefore(
  //   platebniMetodyEl,
  //   signature.nextElementSibling
  // );
}

// Update footer links
function updateFooterLinks() {
  const footerLinks = document.querySelector(".footer-links-icons");
  if (footerLinks) {
    footerLinks.insertAdjacentHTML("afterbegin", footerPhone);
    footerLinks.insertAdjacentHTML("beforeend", footerMail);
  }
}

// Handle footer headers
function handleFooterHeaders() {
  const headers = document.querySelectorAll(".custom-footer h4");
  if (!headers.length || window.innerWidth >= 768) return;

  headers.forEach((header) => {
    header.addEventListener("click", () => {
      header.classList.toggle("--active");
      header.parentElement.classList.toggle("--active");
    });
  });
}

//  Reviews
async function handleReviews() {
  try {
    const response = await fetch("/hodnoceni-obchodu");
    const text = await response.text();

    const parser = new DOMParser();
    const doc = parser.parseFromString(text, "text/html");

    const allReviews = doc.querySelectorAll(
      '.vote-wrap[data-testid="gridRating"]'
    );

    const filteredReviews = Array.from(allReviews)
      .filter((review) => {
        const content = review.querySelector(".vote-content");
        return content && content.textContent.trim().length > 0;
      })
      .slice(0, 5);

    if (filteredReviews.length === 0) return;

    let reviewsContainer = document.querySelector(
      ".welcome-wrapper .review-container.review-obchodu"
    );
    if (!reviewsContainer) {
      reviewsContainer = document.createElement("div");
      reviewsContainer.classList.add("review-container", "review-obchodu");

      const welcome = document.querySelector(".welcome-text");
      if (welcome) {
        welcome.append(reviewsContainer);
      } else {
        console.error("welcome container not found");
      }
    } else {
      console.log("Reviews container already exists");
    }

    // Swiper structure
    const swiper = document.createElement("div");
    swiper.className = "swiper";
    const swiperContainer = document.createElement("div");
    swiperContainer.classList.add(
      "swiper-container",
      "review-swiper",
      "external"
    );
    const wrapper = document.createElement("div");
    wrapper.className = "swiper-wrapper";

    for (const review of filteredReviews) {
      const stars = review.querySelector('[data-testid="gridStars"]');
      const text = review.querySelector('[data-testid="textRating"]');
      const name = review.querySelector('[data-testid="textRatingAuthor"]');
      const image = review.querySelector(".vote-pic");

      if (!stars || !text || !name) continue;

      const slide = document.createElement("div");
      slide.classList.add("swiper-slide");

      const textEl = document.createElement("div");
      textEl.className = "vote-content";
      textEl.textContent = `„${text.textContent.trim()}“`;
      slide.appendChild(textEl);

      const footerEl = document.createElement("div");
      footerEl.className = "vote-footer";

      footerEl.appendChild(stars.cloneNode(true));

      if (image) {
        footerEl.appendChild(image.cloneNode(true));
      }

      const nameText = document.createTextNode(name.textContent.trim());
      footerEl.appendChild(nameText);

      slide.appendChild(footerEl);

      wrapper.appendChild(slide);
    }
    const prevBtn = document.createElement("div");
    prevBtn.className = "swiper-button-prev";
    const nextBtn = document.createElement("div");
    nextBtn.className = "swiper-button-next";

    const controls = document.createElement("div");
    controls.className = "controls-row";

    const pagination = document.createElement("div");
    pagination.className = "swiper-pagination review-pagination";

    controls.appendChild(pagination);
    controls.appendChild(prevBtn);
    controls.appendChild(nextBtn);

    swiper.appendChild(wrapper);
    swiperContainer.appendChild(swiper);
    swiperContainer.appendChild(controls);

    reviewsContainer.appendChild(swiperContainer);

    new Swiper(".review-swiper.external .swiper", {
      navigation: {
        nextEl: ".review-swiper.external .swiper-button-next",
        prevEl: ".review-swiper.external .swiper-button-prev",
      },
      pagination: {
        el: ".review-swiper.external .swiper-pagination",
        clickable: true,
      },
      slidesPerView: 1,
      spaceBetween: 20,
    });
  } catch (error) {
    console.error("Loading ratings error:", error);
  }
}
function handleServisReview() {
  const goalContainer = document.querySelector("#zakazkove > div");
  const servisReview = document.querySelector(".custom-footer__banner28 ");
  if (!goalContainer || !servisReview) return;
  if (servisReview.parentElement === goalContainer) return;
  goalContainer.appendChild(servisReview);
  new Swiper(".servis-review-swiper .swiper", {
    navigation: {
      nextEl: ".servis-review-swiper .swiper-button-next",
      prevEl: ".servis-review-swiper .swiper-button-prev",
    },
    pagination: {
      el: ".servis-review-swiper .swiper-pagination",
      clickable: true,
    },
    slidesPerView: 1,
    spaceBetween: 20,
  });
}
if (isPageType(["homepage"])) {
  handleHomepage();
  document.addEventListener("ShoptetDOMContentLoaded", handleHomepage);

  handleReviews();
  handleServisReview();
}
handleFooter();
document.addEventListener("ShoptetDOMContentLoaded", handleFooter);
// ! Category page
function handleCategoryBanner(reload = false) {
  function moveCategoryBanners() {
    const categoryBanners = document.querySelectorAll(".banner-category");

    const firstProductBlock = document.querySelector("#products");
    const secondProductBlock = document.querySelector(
      ".products-block:not(#products)"
    );

    if (
      secondProductBlock &&
      (dataLayer?.[0]?.shoptet?.pageType !== "homepage" ||
        document.body.classList.contains("in-znacka"))
    ) {
      const secondBlockProducts =
        secondProductBlock.querySelectorAll(".product");
      for (let i = 0; i < secondBlockProducts.length; i++) {
        const product = secondBlockProducts[i];
        if (firstProductBlock) {
          firstProductBlock.appendChild(product);
        }
      }

      secondProductBlock.remove();
    }

    for (let index = 0; index < categoryBanners.length; index++) {
      const categoryBanner = categoryBanners[index];
      categoryBanner.classList.add("product");

      if (categoryBanner && firstProductBlock) {
        const products = firstProductBlock.querySelectorAll(".product");
        let whereToAppend = null;

        switch (index) {
          case 0:
            whereToAppend = products[8];
            break;
          case 1:
            whereToAppend = products[12];
            break;
        }

        if (whereToAppend) {
          whereToAppend.after(categoryBanner);
          categoryBanner.style.display = "";
        } else {
          categoryBanner.style.display = "none";
        }
      }
    }
  }
  moveCategoryBanners();

  function handleUpBtn() {
    const upBtn = document.querySelector(".pagination-top");
    if (upBtn) {
      upBtn.classList.add("btn", "btn-secondary");
    }
    const textBtn = upBtn?.querySelector("strong.js-scroll-top");
    if (textBtn) {
      textBtn.textContent = "Zpět nahoru";
    }
  }
  handleUpBtn();

  function handlePaginationWrapper() {
    const paginationWrapper = document.querySelector(".pagination-wrapper");
    if (paginationWrapper) {
      const paginationContent = paginationWrapper.innerHTML.trim();
      if (paginationContent === "") {
        paginationWrapper.style.display = "none";
      }
    }
  }
  handlePaginationWrapper();
}
function handleProductImage() {
  const products = document.querySelectorAll(".product");
  if (products.length) {
    for (let product of products) {
      const image = product.querySelector(".image > img");
      if (image) {
        image.src = image.src.replace("/detail/", "/orig/");
        if (image.hasAttribute("data-src"))
          image.setAttribute(
            "data-src",
            image.getAttribute("data-src").replace("/detail/", "/orig/")
          );
        if (image.hasAttribute("data-next"))
          image.setAttribute(
            "data-next",
            image.getAttribute("data-next").replace("/detail/", "/orig/")
          );
      }
    }
  }
}
if (isPageType(["category"])) {
  handleCategoryBanner();
  document.addEventListener("ShoptetDOMContentLoaded", function () {
    handleCategoryBanner(true);
  });
  handleProductImage();
  document.addEventListener("ShoptetDOMContentLoaded", handleProductImage);
  document.addEventListener("ShoptetDOMPageContentLoaded", handleProductImage);
}

// ! Detail product page
function handleProductDetailPage() {
  const productDetailBanner = document.querySelector(
    "[class*='custom-footer__banner']:has(#zakazkova-vyroba)"
  );
  const footer = document.querySelector("#footer");
  if (productDetailBanner && footer) {
    footer.insertAdjacentElement("beforebegin", productDetailBanner);
  }
  const basicDescriptionHeader = document.querySelector(
    ".basic-description h3"
  );
  if (basicDescriptionHeader) {
    basicDescriptionHeader.textContent = "Popis produktu";
  }
  const extendedDescription = document.querySelector(".extended-description");
  if (extendedDescription) {
    extendedDescription.id = "extended-description";
  }
  const extendedDescriptionHeader = document.querySelector(
    ".extended-description h3"
  );
  extendedDescriptionHeader.textContent = "Specifikace";
}
function insertExtraTabs() {
  const tabList = document.querySelector("#p-detail-tabs");
  const extended = document.querySelector("#extended-description");
  const tabContent = document.querySelector("#tab-content");

  if (!tabList || !tabContent) return;

  if (extended && !tabList.querySelector('[href="#extended-description"]')) {
    const paramTab = document.createElement("li");
    paramTab.className = "shp-tab";
    paramTab.innerHTML = `<a href="#extended-description" class="shp-tab-link" role="tab" data-toggle="tab">Parametry</a>`;
    tabList.appendChild(paramTab);
  }

  const zakazId = "zakazkova-vyroba";
  let zakazTab = tabList.querySelector(`[href="#${zakazId}"]`);
  if (!zakazTab) {
    zakazTab = document.createElement("li");
    zakazTab.className = "shp-tab";
    zakazTab.innerHTML = `<a href="#${zakazId}" class="shp-tab-link" role="tab" data-toggle="tab">Zakázková výroba</a>`;
    tabList.appendChild(zakazTab);
  }

  const videoTab = tabList.querySelector("[data-testid='tabRelatedVideos']");
  if (videoTab && zakazTab) {
    tabList.insertBefore(videoTab, zakazTab);
  }
}
if (isPageType(["productDetail"])) {
  handleProductDetailPage();
  insertExtraTabs();
  $(document).on("click", ".shp-tab-link", function (e) {
    var target = $(this).attr("href");
    if ($(target).length > 0) {
      e.preventDefault();
      $("html,body").animate(
        {
          scrollTop: $(target).offset().top - 30,
        },
        700
      );
    }
  });
}
function swiperProducts() {
  const productBlock = document.querySelector(
    ".products-related-header + .products-block"
  );
  if (!productBlock) return;

  const productElements = Array.from(productBlock.querySelectorAll(".product"));

  const swiperContainer = document.createElement("div");
  const swiperClass = `custom-swiper`;
  swiperContainer.className = `swiper-container ${swiperClass}`;

  const swiper = document.createElement("div");
  swiper.className = "swiper";

  const wrapper = document.createElement("div");
  wrapper.classList.add("swiper-wrapper");

  productElements.forEach((product) => {
    product.classList.add("swiper-slide");
    wrapper.appendChild(product);
  });

  swiper.appendChild(wrapper);
  swiperContainer.appendChild(swiper);

  const controls = document.createElement("div");
  controls.className = "controls-row container";

  const pagination = document.createElement("div");
  pagination.className = "swiper-pagination classix-pagination";

  const prevBtn = document.createElement("div");
  prevBtn.className = "swiper-button-prev classix-prev";

  const nextBtn = document.createElement("div");
  nextBtn.className = "swiper-button-next classix-next";

  controls.appendChild(pagination);
  controls.appendChild(prevBtn);
  controls.appendChild(nextBtn);

  productBlock.parentNode.replaceChild(swiperContainer, productBlock);
  swiperContainer.appendChild(controls);

  new Swiper(`.${swiperClass} .swiper`, {
    loop: false,
    navigation: {
      nextEl: `.${swiperClass} .classix-next`,
      prevEl: `.${swiperClass} .classix-prev`,
    },
    pagination: {
      el: `.${swiperClass} .classix-pagination`,
      clickable: true,
    },
    slidesPerView: 3,
    spaceBetween: 20,
    breakpoints: {
      0: { slidesPerView: 1.25, spaceBetween: 16 },
      480: { slidesPerView: 2 },
      768: { slidesPerView: 3 },
      1200: { slidesPerView: 6 },
    },
  });
}
if (isPageType(["homepage", "productDetail"])) swiperProducts();

// ! Collections page
function handleCollectionsPage() {
  const collectionColors = document.querySelector(".collections__colors");

  const interierBanner = document.querySelector(
    "[class*='custom-footer__banner']:has(#smlxl)"
  );
  const arrayBanner = document.querySelector(
    "[class*='custom-footer__banner']:has(.interier-text)"
  );

  if (interierBanner) {
    collectionColors?.insertAdjacentElement("afterend", interierBanner);
  }
  if (document.body.classList.contains("id-849")) {
    if (arrayBanner) {
      collectionColors.insertAdjacentElement("beforebegin", arrayBanner);
    }
  }
}
if (
  document.body.classList.contains("id-849") ||
  document.body.classList.contains("id-852") ||
  document.body.classList.contains("id-887")
) {
  handleCollectionsPage();
  document.addEventListener("ShoptetDOMContentLoaded", handleCollectionsPage);
}

// ! Contact page
function handleContactPage() {
  const original = document.querySelector(".container.footer-links-icons");

  const target = document.querySelector(".contact-p");

  if (original && target) {
    const clone = original.cloneNode(true);
    clone.classList.add("contact-links-icons");
    target.insertAdjacentElement("afterend", clone);
  } else {
    console.warn("Element not found for cloning:");
  }
  const submitBtn = document.querySelector('input[type="submit"].btn-primary');

  if (submitBtn && submitBtn.value === "Odeslat") {
    submitBtn.value = "Odeslat zprávu";
  }

  const contactBanner = document.querySelector(".contact-banner");
  if (contactBanner) {
    const footer = document.querySelector("#footer");
    if (footer) {
      footer.insertAdjacentElement("beforebegin", contactBanner);
    }
  }
}
handleContactPage();

// ! Cart
function createCartFooter() {
  const footer = document.createElement("footer");
  footer.classList.add("ordering-process-footer");

  footer.innerHTML = `
    <div class="container">
      <div class="contact-box phone-wrapper">
        <span>Po-Pá: 07:30 - 16:00</span>
      </div>
      <div class="contact-box mail-wrapper">
        <span>Reagujeme do 24 hodin</span>
      </div>
       <div class="secure-payment">
        <span>Bezpečná platba</span>
        <img src="/user/documents/upload/miranda/icons/Frame 1939.svg" width="192" height="23" alt="Visa, MasterCard, Maestro, PayPal" loading="eager">
      </div>
    </div>
  `;
  return footer;
}
function addContactInfo(footer) {
  const cartProjectMail = document.querySelector(".contact-box .mail");
  const cartProjectPhone = document.querySelector(".contact-box .tel");

  const phoneWrapper = footer.querySelector(".phone-wrapper");
  if (cartProjectPhone && phoneWrapper) {
    const phoneClone = cartProjectPhone.cloneNode(true);
    phoneClone.classList.add("project-phone");
    phoneWrapper.prepend(phoneClone);
  }

  const mailWrapper = footer.querySelector(".mail-wrapper");
  if (cartProjectMail && mailWrapper) {
    const mailClone = cartProjectMail.cloneNode(true);
    mailClone.classList.add("project-mail");
    mailWrapper.prepend(mailClone);
  }
}
function handleCart() {
  const overallWrapper = document.querySelector(".overall-wrapper");
  const footerExists = document.querySelector(".ordering-process-footer");

  const footer = createCartFooter();
  addContactInfo(footer);
  overallWrapper.appendChild(footer);
}
if (isPageType(["cart", "billingAndShipping", "customerDetails"])) handleCart();

function handleCartSecondStep() {
  const deliveryHeading = document.querySelector(".order-icon.order-delivery");
  if (deliveryHeading) {
    deliveryHeading.textContent = "Způsob dopravy";
    const selectCountryRow = document.querySelector(
      "#select-country-payment > div > .row"
    );
    if (selectCountryRow) {
      selectCountryRow.prepend(deliveryHeading);
    }
  }
  const paymentHeading = document.querySelector(".order-icon.order-payment");
  if (paymentHeading) paymentHeading.textContent = "Způsob platby";

  const f = document.querySelector("#checkoutSidebar");

  const orderSummaryInner = document.querySelector(".order-summary-inner");
  const orderSummaryItem = document.querySelector(".order-summary-item.price");
  const orderRecapitulation = document.querySelector(
    "#shipping-billing-summary"
  );
  const nextStepButton = document.querySelector(".next-step.next-step--step-1");
  if (orderSummaryItem && orderSummaryInner && nextStepButton) {
    nextStepButton.insertAdjacentElement("beforebegin", orderSummaryItem);
    orderSummaryItem.appendChild(nextStepButton);
  }
  // orderSummaryInner.appendChild(orderRecapitulation);

  const nextStepBack = document.querySelector(".next-step-back");
  if (nextStepBack) nextStepBack.textContent = "Zpět k nákupnímu košíku";
}
if (isPageType(["billingAndShipping"])) {
  let shippingUpdated = false;
  let billingUpdated = false;

  function tryHandleCartSecondStep() {
    if (shippingUpdated && billingUpdated) {
      handleCartSecondStep();
      shippingUpdated = false;
      billingUpdated = false;
    }
  }

  document.addEventListener("ShoptetShippingMethodUpdated", function () {
    shippingUpdated = true;
    tryHandleCartSecondStep();
  });

  document.addEventListener("ShoptetBillingMethodUpdated", function () {
    billingUpdated = true;
    tryHandleCartSecondStep();
  });
}

function handleCheckout() {
  const orderSummaryItem = document.querySelector(".order-summary-item.price");
  const orderSummaryInner = document.querySelector(".order-summary-inner");
  const nextStepButton = document.querySelector(".next-step.next-step--step-2");
  if (orderSummaryItem && orderSummaryInner && nextStepButton) {
    nextStepButton.insertAdjacentElement("beforebegin", orderSummaryItem);
    const formGroups = document.querySelectorAll(
      "#checkoutSidebar .form-group"
    );
    if (formGroups.length) {
      formGroups.forEach((group) => {
        orderSummaryItem.appendChild(group);
      });
    }
    orderSummaryItem.appendChild(nextStepButton);
  }

  const formGroups = document.querySelectorAll(
    "#checkoutContent .form-group.js-validated-element-wrapper.smart-label-wrapper"
  );
  if (formGroups.length) {
    formGroups.forEach((group) => {
      let text;
      const label = group.querySelector("label");
      if (label) {
        const spanInLabel = label.querySelector("span");
        if (spanInLabel) text = spanInLabel.textContent + " *";
        else text = label.textContent.trim();
      }
      const input = group.querySelector("input.form-control");
      if (input) input.placeholder = text;
    });
  }
}
if (isPageType(["customerDetails"])) handleCheckout();

// document.querySelector(".back-to-top").addEventListener("wheel", (event) => {
//   const scrollAmount = event.deltaY / 30; // Где 'n' — ваше число, которое вы хотите изменить
//   window.scrollBy(0, scrollAmount);
//   event.preventDefault(); // Чтобы предотвратить стандартное поведение браузера
// });

// document.querySelector(".back-to-top").addEventListener("click", () => {
//   const step = 100; // пикселей за кадр, меньше = медленнее

//   function scrollUp() {
//     if (window.scrollY > 0) {
//       window.scrollBy(0, -step);
//       requestAnimationFrame(scrollUp);
//     }
//   }

//   requestAnimationFrame(scrollUp);
// });
